import { render, staticRenderFns } from "./YoukePingfenPaiming.vue?vue&type=template&id=371b2097&scoped=true&"
import script from "./YoukePingfenPaiming.vue?vue&type=script&lang=js&"
export * from "./YoukePingfenPaiming.vue?vue&type=script&lang=js&"
import style0 from "./YoukePingfenPaiming.vue?vue&type=style&index=0&id=371b2097&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371b2097",
  null
  
)

export default component.exports